import { Carousel, Modal, message } from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import ReactImageMagnify from "react-image-magnify";
import { AuthContext } from "../../Contexts/AuthContext";
import axios from "../../config/axios";
import styles from "./ProductDescriptionSlider.module.scss";
import { BsZoomIn } from "react-icons/bs";
import { SlClose } from "react-icons/sl";
import { CiImageOff } from "react-icons/ci";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { getVariantImages } from "../../utils/helpers";

const ProductDescriptionSlider = ({ product, variant }) => {
    const [productInWishlist, setProductInWishlist] = useState(false);
    const { user, isAuthenticated } = useContext(AuthContext);
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const slider1 = useRef(null);
    const slider2 = useRef(null);
    const [showImageModal, setShowImageModal] = useState(false);
    const [activeImage, setActiveImage] = useState(null);
    const isBadge = product.new_sign || product.leaf_sign_2 || product.leaf_sign_1;

    // fall back to any variant that actually has images
    const variantImages = getVariantImages(variant, product.variants);
    const hasImages = variantImages.length > 0;

    useEffect(() => {
        if (variantImages.length > 0) {
            setActiveImage(variantImages[0]);
        }
    }, [variantImages]);

    useEffect(() => {
        setNav1(slider1.current);
        setNav2(slider2.current);
    }, []);

    useEffect(() => {
        if (user?.wishlist?.includes(product.id)) {
            setProductInWishlist(true);
        }
    }, [product.id, user?.wishlist]);

    const addToWishlist = () => {
        if (!isAuthenticated) {
            message.error("You need to login first!");
            return;
        }

        setProductInWishlist(true);
        message.success("Product added to favorites!");

        let wishlist = user.wishlist;
        wishlist.push(product.id);
        let payload = {
            wishlist: wishlist,
        };
        axios.patch(`/users/update`, payload, { withCredentials: true }).then((response) => { });
    };

    const removeFromWishlist = () => {
        if (!isAuthenticated) return;
        setProductInWishlist(false);
        message.success("Product removed from favorites!");

        let wishlist = user.wishlist;
        let index = user.wishlist.indexOf(product.id);
        wishlist.splice(index, 1);

        let payload = {
            wishlist: wishlist,
        };
        axios.patch(`/users/update`, payload, { withCredentials: true }).then((response) => { });
    };

    return (
        <div className={styles.productDescriptionSlider}>
            <div className={styles.product_top}>
                {/* slider */}
                {!hasImages && (
                    <div className={styles.no_image}>
                        <CiImageOff fontSize="8rem" />
                        <span className={styles.no_image_text}>Image will be uploaded soon</span>
                    </div>
                )}
                {hasImages && (<Carousel
                    asNavFor={nav2}
                    ref={slider1}
                    style={{ padding: 20 }}
                    dots={false}
                    slidesToShow={1}
                    afterChange={(current) => {
                        if (variantImages.length > 0) {
                            setActiveImage(variantImages[current]);
                        }
                    }}
                    pauseOnHover={true}
                    pauseOnFocus={true}
                >
                    {variantImages.map((img, index) => (
                        <div key={index} className="position-relative">
                            <ReactImageMagnify
                                {...{
                                    smallImage: {
                                        alt: "product_image",
                                        isFluidWidth: true,
                                        src: img,
                                        padding: 100,
                                    },
                                    className: window.innerWidth > 768 ? styles.product_image : styles.product_image_mobile,
                                    largeImage: {
                                        src: img,
                                        width: 1200,
                                        height: 1800,
                                    },
                                    isHintEnabled: false,
                                    shouldHideHintAfterFirstActivation: false,
                                    isActivatedOnTouch: false,
                                    enlargedImagePortalId: window.innerWidth > 768 ? "customProductDescriptionSliderPortal" : null,
                                    shouldUsePositiveSpaceLens: true,
                                }}
                            />
                        </div>
                    ))}
                </Carousel>)}

                {hasImages && (
                    <>
                        <LeftOutlined onClick={() => slider2.current.prev()} className={styles.left_outlined} />
                        <RightOutlined onClick={() => slider2.current.next()} className={styles.right_outlined} />
                    </>
                )}

                {/* bottom */}
                <div className={styles.bottom}>
                    <div
                        className="position-absolute d-flex flex-column gap-3"
                        style={{
                            left: 10,
                            top: 30,
                        }}
                    >
                        {product.leaf_sign_2 && (
                            <img src={"https://desi-fresh.b-cdn.net/components_static/ProductDescriptionSlider/bio.svg"} alt="bio_img" />
                        )}
                        {product.new_sign && (
                            <img src={"https://desi-fresh.b-cdn.net/components_static/ProductDescriptionSlider/new.svg"} alt="new_img" />
                        )}
                        {product.leaf_sign_1 && (
                            <img src={"https://desi-fresh.b-cdn.net/components_static/ProductDescriptionSlider/vegan.svg"} alt="vegan" />
                        )}
                    </div>
                    <div
                        className={`${styles.product_image_overlay} ${isBadge ? styles.product_image_overlay_badge : ""}`}
                    >
                        {productInWishlist ? (
                            <img
                                onClick={removeFromWishlist}
                                src={"/icon/wishlist-added.svg"}
                                alt="favorites_fill"
                                height={34}
                                role="button"
                            />
                        ) : (
                            <img onClick={addToWishlist} src={"/icon/wishlist.svg"} alt="favorites" height={34} role="button" />
                        )}
                        {variant?.discount_percentage > 0 && (
                            <div className={styles.discount_text}>
                                <div className={styles.offer_percent}>Save {parseInt(variant.discount_percentage)}%</div>
                            </div>
                        )}
                        {/* <div>
                                {" "}
                                +100{" "}
                                <img
                                    src={"https://desi-fresh.b-cdn.net/components_static/ProductDescriptionSlider/points.svg"}
                                    alt="points"
                                />{" "}
                            </div> */}
                        {/* <div> Valid Until 15.02.2023 </div> */}
                    </div>

                    <div
                        className="position-absolute"
                        style={{
                            left: 15,
                            bottom: 20,
                        }}
                    >
                        {product.freezing && <img src="https://desi-fresh.b-cdn.net/components_static/frozen_2.svg" alt="freezing" />}

                        {product.refrigeration && (
                            <img src="https://desi-fresh.b-cdn.net/components_static/frozen.svg" alt="not-freezing" />
                        )}

                        {/*{product.freezing ? (*/}
                        {/*    <img src="https://desi-fresh.b-cdn.net/components_static/frozen_2.svg" alt="freezing" />*/}
                        {/*) : (*/}
                        {/*    <img src="https://desi-fresh.b-cdn.net/components_static/frozen.svg" alt="not-freezing" />*/}
                        {/*)}*/}
                    </div>
                    <div
                        className="position-absolute"
                        style={{
                            right: 15,
                            bottom: 20,
                        }}
                        onClick={() => {
                            navigator.clipboard.writeText(window.location.href);
                            message.success("Link copied to clipboard. Share it with your friends!");
                        }}
                        role="button"
                    >
                        <img src={"https://desi-fresh.b-cdn.net/components_static/ProductDescriptionSlider/share.svg"} alt="share_icon" />
                    </div>
                    {hasImages && (
                        <div
                            className="position-absolute"
                            style={{
                                right: 46,
                                bottom: 20,
                            }}
                            onClick={() => setShowImageModal(true)}
                            role="button"
                        >
                            <BsZoomIn size={23} />
                        </div>
                    )}
                    {showImageModal && (
                        <Modal
                            open={showImageModal}
                            onCancel={() => setShowImageModal(false)}
                            bodyStyle={{
                                padding: 0,
                            }}
                            centered
                            footer={null}
                            closeIcon={<SlClose size={23} />}
                        >
                            <img src={activeImage} alt="active_image" className="img-fluid" />
                        </Modal>
                    )}
                </div>
            </div>
            <div className={styles.fresh_authentic_wrapper}>
                <div className={styles.fresh_authentic}>Fresh and Authentic</div>
            </div>

            {hasImages && (<div className={`${styles.small_carousel} row pt-4`}>
                <div className="col-1">
                    <div className="d-flex align-items-center h-100">
                        <img
                            src={"https://desi-fresh.b-cdn.net/components_static/ProductDescriptionSlider/arrow_left_active.svg"}
                            alt="slide_right"
                            onClick={() => slider2.current.prev()}
                            role="button"
                        />
                    </div>
                </div>
                <div className="col-10">
                    <Carousel
                        asNavFor={nav1}
                        ref={slider2}
                        draggable
                        autoplay
                        slidesToShow={variantImages.length > 3 ? 3 : variantImages.length}
                        dots={false}
                        focusOnSelect={true}
                        autoplaySpeed={3000}
                        pauseOnHover={true}
                        pauseOnFocus={true}
                    >
                        {variantImages.map((img, index) => (
                            <div key={index}>
                                <img src={img} alt={`product-img-${index}`} height={50} className={styles.thumbs_image} />
                            </div>
                        ))}
                    </Carousel>
                </div>
                <div className="col-1">
                    <div className="d-flex align-items-center h-100">
                        <img
                            src={"https://desi-fresh.b-cdn.net/components_static/ProductDescriptionSlider/arrow_right.svg"}
                            alt="slide_right"
                            onClick={() => slider2.current.next()}
                            role="button"
                        />
                    </div>
                </div>
            </div>)}
        </div>
    );
};

export default ProductDescriptionSlider;
